import codes from '@/codes'
import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { system as wsfinder } from '@/service/api/wsfinder'

export default {
  components: {
    cSwitch,
  },
	data : () => { return { lock : false, codes : codes, model : { ext : '-', is_alive : true } } },
  methods: {
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    cancel: function() { this.$router.replace({ name: 'wsfinder_spattern', params: { id: this.model.id}}); },
    list: function() { this.$router.push({ name: 'wsfinder_spattern'}); },
    async save() {
      if(!(this.model.type || '').trim()) { return this.$toastr.e('Type is Require.'); }
      if(!(this.model.ext || '').trim()) { return this.$toastr.e('Ext is Require.'); }
      if(!(this.model.category || '').trim()) { return this.$toastr.e('Category is Require.'); }
      if(!(this.model.code || '').trim()) { return this.$toastr.e('Code is Require.'); }
      if(this.model.is_alive == undefined) { return this.$toastr.e('Use is Require.'); }

      if(!this.regex_valid(this.model.code)) { return this.$toastr.e("No vaild expression"); }

      try {
        let check_id = '';
        check_id = this.model.id ? `${await wsfinder.updateSys(this.model)}` : `${await wsfinder.insertSys(this.model)}`;

        let rs = check_id;
        if(!rs.error) {
          this.$toastr.s('Saved.', this.$route.name);
        } else {
          this.$toastr.e('delete', "failed");
        }
        this.$emit('refresh'); this.cancel();
        return;
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.edit.vue', 'load item', id);
      if(id !== 'add') {
        try {
          let rs = await wsfinder.detailSys({id : id});
          this.model = Object.assign({}, this.model, rs.body);

          if(!(this.model.ext || '').trim()) { this.model.ext = '-' }
        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText),this.cancel(); }
      }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); this.$on('refresh', this.refresh()) } },
  created: function() { console.log('pattern.edit.vue', 'created'); },
  destroyed: function() { console.log('pattern.edit.vue', 'destroyed'); },
  mounted: function() {
    console.log('pattern.edit.vue', 'mounted');
    this.get(this.$route.params.id);
  }
}